import { createContext, useContext, useEffect, useRef, useState } from "react";


const Context = createContext([]);
const count = Object.keys(window['game_data']?.questions || {}).length
const time_overhead = window.location.search.includes('dev')? 3000 : 30;
const time_for_question = (count - 1) * 10;
const time_total = count <= 4 ? time_overhead :  time_for_question;
export function ClockProvider({ children }) {
  const [clock, setClock] = useState({
	  text:'00:00',
  });
  const [passed,setPassed] = useState(null);

  function updateClock(update){
	const l = {...clock,...update};
    setClock(l);
  }

  let interval = useRef(null);
  const hasPassed = useRef(0);
  function start(){
	  if(window.location.search.includes('pause')) return;
	  if(window['builder'] === true) return;

	  if(interval.current !== null) return;

	  interval.current = setInterval(()=>{
		tick();
	  },1000)
  }
	function tick() {
		hasPassed.current += 1;
		setPassed(hasPassed.current);
		const percent = hasPassed.current / time_total * 100;

		const minutes = Math.floor(hasPassed.current / 60);
		const seconds = hasPassed.current - minutes * 60;
		const minutes_pad = minutes.toString().padStart(2, '0');
		const seconds_pad = seconds.toString().padStart(2, '0');
		const text = `${minutes_pad}:${seconds_pad}`;
		updateClock({ passed: hasPassed.current, percent, text });
	}

  function stop(reset, resetHard){
	  clearInterval(interval.current);
	  if(reset === true){
		hasPassed.current = 0;
		setClock({passed:0,text:"00:00"})
		if(!resetHard){
			interval.current = setInterval(()=>{
				tick();
			},1000)  
		}
	  }
  }
  useEffect(()=>{
	if(window['builder'] === true) return;
	if(hasPassed.current >= time_total){
		clearInterval(interval.current);
		setClock({time_out:true})
	}
  },[hasPassed?.current])
  return (
	<Context.Provider value={[clock, updateClock,start,stop]}>
		{children}
	</Context.Provider>
  );
}

export function useClockContext() {
  return useContext(Context);
}